import { useEffect } from 'react';

/**
 * Custom hook to handle clicks outside a specified element.
 * @param {React.RefObject} ref - The ref of the element to detect outside clicks for.
 * @param {Function} callback - The function to call when a click outside is detected.
 */
export function useOutsideClick(ref, callback) {
  useEffect(() => {
    function handleClickOutside(event) {
      if (ref.current && !ref.current.contains(event.target)) {
        callback();
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [ref, callback]);
}
